module.exports = __webpack_public_path__ + "img/Left-Bottom.7a2fa349.svg";